module.exports = __webpack_public_path__ + "static/media/2025_Sermeq_Helicopters.0f4544f3.pdf";